import { render, staticRenderFns } from "./NewParapharmacyPrescription.vue?vue&type=template&id=79a1a73d"
import script from "./NewParapharmacyPrescription.vue?vue&type=script&lang=js"
export * from "./NewParapharmacyPrescription.vue?vue&type=script&lang=js"
import style0 from "./NewParapharmacyPrescription.vue?vue&type=style&index=0&id=79a1a73d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports